export default {
        "logout-success": "ログアウト成功",
        "logout-error": "ログアウトに失敗しました",
        "confirm": "確認",
        "copySuccess": "コピーしました",
        "server": {
            "selectServer": "サーバー選択",
            "serverAmerica": "America",
            "serverEurope": "Europe",
            "serverAsia": "Asia",
            "serverHMT": "HMT",
            "serverSEA": "SEA",
            "noRole": "イベントに参加可能なアカウントがありません。\n『鳴潮』をスタートしましょう！",
            "noRole2": "キャラクターが存在しません",
            "noOtherRole": "他のキャラクターを確認できず、\n切り替えることができません。"
        },
        "uidlogin": { 
            "enterCode": "コードを入力してください",
            "enterCode2": "正しいコードを入力してください",
            "sendCode": "コードを送信",
            "agree": "利用規約とプライバシーポリシーを読み、同意してください",
            "sended": "送信済み",
            "tipUid": "UIDを入力してください",
            "tipUid2": "正しいUIDを入力してください",
            "login": "ログイン",
            "loginFail": "ログインに失敗しました。UIDとコードを確認してください",
            "loginSuccess": "ログイン成功",
            "sendFail": "ロールが見つかりませんでした",
            "sendFail2": "送信失敗",
            "sendFast": "送信すすみすす",
            "sendFast2": "送信すすみすす、{time}後に再試行してください",
            "codeInvaild": "コードが無効です"
        },
        "share-tips": "長押しで画像を保存して共有"
};
